import React from 'react'

const Statements = props => {

  const generateStatements = () => {
    if (props.statements && props.statements.length > 0) {
      const list = props.statements.map((entry, index) => {
        return (
          <div style={statementBox} key={index}>
            <h3 style={statementTitle} >{entry.name}</h3>
            <p style={statementBlurb} >{entry.statement}</p>
          </div>
        )
      })
      return list
    } else {
      return null
    }
  }

  return (
    <div>
      {props.statements && props.statements.length > 0 && (
        <h2>Candidate Statements:</h2>
      )}
      {generateStatements()}
    </div>
  )
}

const statementBox = {
  border: '2px solid #333333',
  borderRadius: '8px',
  marginBottom: '1rem'
}

const statementTitle = {
  color: '#ffffff',
  background: '#333333',
  padding: '8px',
}

const statementBlurb = {
  padding: '8px',
}

export default Statements
